<template>
<deleted-page-component>
    <div class="content-container">
        <p class="text">
            {{userName}} is not avaliable anymore. Hit the button below and continue journey with {{dealerName}} or get new Digital Business Card
        </p>
     <p class="expert">Your new expert is</p>
    <div v-if="isExpert" class="user-block">
        <img class="avatar" :src="avatar" alt="Salesperson avatar">
        <div class="name">
            <span>{{firstName}}</span>
            <span>{{lastName}}</span>
        </div>
    </div>
    <a class="button-primary" :href="dbcLink">Open new Digital Business Card</a>
    <span class="annotation">You will recieve the text message with the valid link</span>
    </div>
  </deleted-page-component>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeletedPage from './deleted-common.vue'
export default {
  components: {
    'deleted-page-component': DeletedPage
  },
  computed: {
    ...mapGetters({
      deletedInfo: 'common/deletedInfo'
    }),
    isExpert () {
      return this.firstName || this.lastName || this.avatar
    },
    firstName () {
      return this.deletedInfo ? this.deletedInfo.newExpertFirstName : null
    },
    lastName () {
      return this.deletedInfo ? this.deletedInfo.newExpertLastName : null
    },
    avatar () {
      return this.deletedInfo ? this.deletedInfo.newExpertIcon : null
    },
    dbcLink () {
      return this.deletedInfo ? this.deletedInfo.customerAppGenerateLink : null
    },
    userName () {
      return this.deletedInfo ? this.deletedInfo.salesPersonFullName : null
    },
    dealerName () {
      return this.deletedInfo ? this.deletedInfo.companyName : null
    }
  },
  methods: {
    ...mapActions({
      getDeletedInfo: 'common/getDeletedInfo'
    })
  }
}
</script>

<style scoped>
p {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    margin: 0;
}

.text{
    margin-bottom: 54px;
}

.expert{
    margin-bottom: 21px;
}

.content-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
}

.user-block{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 48px;
}

.user-block > .avatar {
    max-width: 64px;
    max-height: 64px;
    flex: 0 0 64px;
    margin-right: 15px;
    border-radius: 50%;
    object-fit: cover;
}

.user-block > .name {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    font-size: 22px;
    text-transform: uppercase;
    font-weight: 700;
}

.button-primary {
    display: inline-block;
    font-size: 24px;
    font-weight: 700;
    padding: 21px;
    color: #2C61D5;
    background-color: #FFFFFF;
}

.annotation{
    font-size: 16;
}
</style>



// WEBPACK FOOTER //
// reassigned.vue?02b918bb